import { IAuthenticationService } from "Interfaces/Services/IAuthenticationService";
import { injectable } from "inversify";

@injectable()
export class AuthenticationService implements IAuthenticationService {

    public isAdministrator(): boolean {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/Services/AuthenticationService.tsx